import { navImgAccess, navImgBeacon, navImgCamera, navImgIOT, navImgOS, navImgRTLS, navImgSensor, navImgWorld } from '@assets/images/nav';

export default {
  product: [
    {
      icon: navImgRTLS,
      title: 'ORBRO OS',
      link: '/en/os',
      path: [
        { text: 'ORBRO Server', link: '/en/os/server' },
        { text: 'ORBRO Edge RTLS', link: '/en/os/rtls' },
        { text: 'ORBRO Edge AI', link: '/en/os/ai' },
        { text: 'L2 Switch', link: '/en/os/switch' },
      ],
    },
    {
      icon: navImgBeacon,
      title: 'RTLS',
      link: '/en/rtls',
      path: [
        { text: 'TwinTracker BLE', link: '/en/rtls/ble' },
        { text: 'TwinTracker AoA', link: '/en/rtls/aoa' },
        { text: 'TwinTracker UWB', link: '/en/rtls/uwb' },
        { text: 'Comfort Kit', link: '/en/rtls/comfort' },
      ],
    },
    {
      icon: navImgAccess,
      title: 'Camera Tracking',
      link: '/en/camera',
      path: [
        { text: 'AI Edge', link: '/en/camera/edge' },
        { text: 'AI Server', link: '/en/camera/server' },
      ],
    },

    {
      icon: navImgAccess,
      title: 'Outdoor Positioning',
      link: 'none',
      path: [
        {
          text: 'GPS Device',
          link: '/en/outdoor/gps',
        },
        {
          text: 'GPS Tag(LoRA)',
          link: '/en/outdoor/lora',
        },
      ],
    },

    {
      icon: navImgSensor,
      title: 'Access',
      link: '/en/access',
      path: [
        { text: 'Access Auto', link: '/en/access/auto' },
        { text: 'Access Lite', link: '/en/access/pro' },
        { text: 'Access Accessory', link: '/en/access/accessory' },
      ],
    },
    {
      icon: navImgSensor,
      title: 'IIoT',
      link: '/en/iot',
      path: [
        { text: 'LoRA Sensor', link: '/en/iot/LoRASensor' },
        { text: 'CO₂ Detector', link: '/en/iot/co2' },
        { text: 'Air Quality Monitor', link: '/en/iot/air' },
        { text: 'Emergency Bell', link: '/en/iot/bell' },
      ],
    },
    // {
    //   icon: navImgWorld,
    //   title: 'Integrated System',
    //   link: '/en/integration',
    //   path: [{ text: 'Robot System', link: '/en/integration/robot' }],
    // },
  ],

  OS: {
    icon: navImgOS,
    title: 'ORBRO OS',
    desc: 'From access control and real-time location tracking to diverse IoT control, ORBRO OS is an integrated service that makes spaces smarter. Experience the smart future now.',
    more: 'Learn more',
    link: '/en/os',
  },

  solution: [
    {
      title: 'Construction',
      path: [
        {
          text: 'Worker Safety Management',
          link: '/enterprise/construction/safety',
        },
        {
          text: 'Digital SOP Management',
          link: '/enterprise/construction/sop',
        },
        {
          text: 'Crane Safety Management',
          link: '/enterprise/construction/equipment',
        },
      ],
    },
    {
      title: 'Smart City',
      path: [
        {
          text: 'Urban Disaster Digital Twin',
          link: '/enterprise/city/digitaltwin',
        },
        {
          text: 'Urban Infrastructure Digital Twin',
          link: '/digital-twin',
        },
        {
          text: 'Parking Lot Vehicle Tracking',
          link: '/enterprise/city/traffic',
        },
      ],
    },
    {
      title: 'Retail',
      path: [
        {
          text: 'Smartphone Display Security Management',
          link: '/enterprise/retail/mobile',
        },
        {
          text: 'Exhibition Visitor Analytics',
          link: '/enterprise/retail/exhibition',
        },
        {
          text: 'Office Asset Management',
          link: '/enterprise/retail/office',
        },
      ],
    },
    {
      title: 'Public Sector',
      path: [
        {
          text: 'Fire Drill Location Tracking System',
          link: '/enterprise/public/training',
        },
        {
          text: 'Crosswalk Pedestrian Safety Solution',
          link: '/enterprise/public/crosswalk',
        },
        {
          text: 'Urban Emergency Call System',
          link: '/enterprise/public/safety',
        },
      ],
    },
    {
      title: 'Manufacturing',
      path: [
        {
          text: 'Steel Logistics Automation',
          link: '/enterprise/manufacturing/steel',
        },
        {
          text: 'Forklift Location Tracking',
          link: '/enterprise/manufacturing/forklift',
        },
        {
          text: 'Real-Time Manufacturing Process Management',
          link: '/enterprise/manufacturing/process',
        },
      ],
    },
    {
      title: 'Logistics',
      path: [
        {
          text: 'Warehouse Asset Tracking',
          link: '/enterprise/logistics/asset',
        },
        {
          text: 'Container Location Tracking',
          link: '/enterprise/logistics/manage',
        },
      ],
    },
    {
      title: 'Medical',
      path: [
        {
          text: 'Medical Waste Robot Management',
          link: '/enterprise/medical/waste',
        },
        {
          text: 'Patient & Medical Equipment Tracking',
          link: '/enterprise/medical/patient',
        },
      ],
    },
    {
      title: 'Education',
      path: [
        {
          text: 'Automated Risk Behavior Detection on Campus',
          link: '/enterprise/education/safety',
        },
      ],
    },
  ],
  world: {
    icon: navImgWorld,
    title: 'ORBRO Digital Twin',
    desc: 'Receive data from people, objects, buildings, and cities in the real world and monitor and manage it in real-time in a digital virtual environment. This enhances productivity and prevents problems, mainly used in industrial and manufacturing fields.',
    more: 'Learn more',
    link: '/en/digital-twin',
  },

  support: [
    {
      title: 'Customer Support',
      path: [
        { text: 'About Us', link: '/en/company' },
        { text: 'Sales Inquiry', link: '/en/request' },
        { text: 'Partnership Inquiry', link: '/en/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: 'Technology',
      path: [
        { text: 'UWB', link: '/en/enterprise/technology/uwb' },
        { text: 'BLE', link: '/en/enterprise/technology/ble' },
        { text: 'Stereo Vision', link: '/en/enterprise/technology/stereo-vision' },
        { text: 'Monocular Vision', link: '/en/enterprise/technology/monocular-vision' },
        { text: 'TDoA', link: '/en/enterprise/technology/tdoa' },
        { text: 'TWR', link: '/en/enterprise/technology/twr' },
        { text: 'Geofence', link: '/en/enterprise/technology/what-is-geofence' },
        { text: 'Digital Twin', link: '/en/enterprise/technology/what-is-digital-twin' },
      ],
    },
    {
      title: 'Software',
      link: 'new',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'ORBRO World', link: 'https://home.orbro.io' },
        { text: 'Release Note', link: '/release-note' },
      ],
    },
    {
      title: 'Social',
      link: 'new',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver', link: 'https://blog.naver.com/orbro_platform' },
        { text: 'Medium', link: 'https://medium.com/@orbro' },
      ],
    },
  ],

  footerSupport: [
    {
      title: 'Support',
      path: [
        { text: 'Blog', link: '/en/blog' },
        { text: 'Sales Inquiry', link: '/en/request' },
        { text: 'Quote Request', link: '/en/pricing/1' },
        { text: 'Partnership Inquiry', link: '/en/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: 'Download',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'ORBRO World', link: 'https://home.orbro.io' },
        { text: 'Release Note', link: '/release-note' },
      ],
    },
    {
      title: 'Social',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver Blog', link: 'https://blog.naver.com/orbro_platform' },
      ],
    },
  ],
};
